import { alarmApi } from './alarmApi';

export const notificationApi = alarmApi.injectEndpoints({
  endpoints: (builder) => ({

    // 🔹 META (sounds + channels)
    getNotificationMeta: builder.query({
      query: () => '/notificationSetting/meta',
    }),

    // 🔹 LIST SETTINGS
    getNotificationSettings: builder.query({
      query: (params) => ({
        url: '/notificationSetting',
        params,
      }),
      providesTags: ['NotificationSettings'],
    }),

    // 🔹 CREATE
    createNotificationSetting: builder.mutation({
      query: (body) => ({
        url: '/notificationSetting',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['NotificationSettings'],
    }),

    // 🔹 UPDATE
    updateNotificationSetting: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `/notificationSetting/${id}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['NotificationSettings'],
    }),

    // 🔹 DELETE
    deleteNotificationSetting: builder.mutation({
      query: (id) => ({
        url: `/notificationSetting/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['NotificationSettings'],
    }),

  }),
  overrideExisting: false,
});

export const {
  useGetNotificationMetaQuery,
  useGetNotificationSettingsQuery,
  useCreateNotificationSettingMutation,
  useUpdateNotificationSettingMutation,
  useDeleteNotificationSettingMutation,
} = notificationApi;
